/**
 * This module's goal is to load any extensions that have been made to lodash and
 * incorporate them into the "_" namespace for access in the broader application.
 */
define(
    'extensions/lodash/lodash4-mixins',[
        'lodash4.base',
        'extensions/lodash/hasValue',
        'extensions/lodash/maybe'
    ],
    function (
        _,
        _hasValue,
        _maybe
    ) {
        'use strict';

        _.mixin(_hasValue);
        _.mixin(_maybe);

        return _;
    }
);

